import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  color: theme.palette.actionItem.main,
  fontSize: '.86667em',
  fontWeight: 500,
  paddingLeft: 0,
  paddingRight: 0,
  minWidth: '32px',
  lineHeight: 'normal',
}));
